import type { Movie } from '@/types/content';

export const movies: Movie[] = [
  {
    id: 'changye-jiangjin',
    title: '长夜将尽',
    originalTitle: 'The End of a Long Night',
    type: '电影',
    region: '国产',
    genres: ['剧情', '悬疑'],
    year: 2025,
    rating: 8.7,
    heat: 9820,
    director: '陈砚舟',
    actors: ['梁牧', '苏晚', '顾承川', '周棠'],
    duration: '128分钟',
    releaseDate: '2025-03-14',
    summary: '一桩尘封十年的旧案，让三个家庭在长夜里重新相遇。',
    synopsis:
      '北方小城的一处老纺织厂在拆迁前被挖出一具无名白骨，刑警队长林知远奉命重启十年前的失踪案。随着调查深入，当年看似毫无关联的三户人家逐渐被同一根线索串联起来。影片以冷峻克制的镜头语言，在迷雾般的小城中展开一场关于真相、愧疚与救赎的追问。长夜终将过去，但每个人心里的那盏灯，究竟还亮着吗？',
    tags: ['犯罪悬疑', '人性拷问', '高口碑'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%2C%20a%20lone%20detective%20silhouette%20under%20a%20flickering%20streetlamp%20in%20fog%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20painterly%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-01-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20foggy%20old%20northern%20factory%20town%20at%20dusk%20with%20one%20lone%20figure%20walking%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-01-backdrop&orientation=landscape',
    featured: true,
  },
  {
    id: 'dushi-zhiguang',
    title: '都市之光',
    originalTitle: 'City Lights',
    type: '电视剧',
    region: '国产',
    genres: ['都市', '爱情', '剧情'],
    year: 2025,
    rating: 8.2,
    heat: 12460,
    director: '许知微',
    actors: ['林晚舟', '韩之屿', '方宁', '赵小满'],
    duration: '全36集',
    releaseDate: '2025-01-20',
    summary: '两个在都市里各自奔跑的人，终于在同一盏路灯下相遇。',
    synopsis:
      '建筑设计师沈light与急诊科医生纪舟在同一座城市生活了七年，却从未真正相遇，直到一场暴雨让他们在同一盏路灯下躲雨。剧集以四季为章节，讲述都市青年在理想、家庭与爱情之间的抉择与成长。没有夸张的戏剧冲突，只有平凡生活里那些被点亮的瞬间，像都市夜幕中永不熄灭的灯火。',
    tags: ['都市情感', '治愈', '口碑热播'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%2C%20a%20young%20woman%20and%20man%20standing%20under%20warm%20street%20lights%20in%20a%20modern%20city%20night%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20painterly%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-02-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20modern%20city%20skyline%20at%20night%20glowing%20with%20warm%20amber%20window%20lights%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-02-backdrop&orientation=landscape',
    featured: true,
  },
  {
    id: 'xingji-huisheng',
    title: '星际回声',
    originalTitle: 'Echoes of the Stars',
    type: '电影',
    region: '欧美',
    genres: ['科幻', '冒险'],
    year: 2024,
    rating: 8.9,
    heat: 15830,
    director: 'Elias Vance',
    actors: ['Marcus Reed', 'Livia Kane', 'Dorian Frost'],
    duration: '146分钟',
    releaseDate: '2024-11-08',
    summary: '人类收到一段来自深空的声音，它说着人类自己的语言。',
    synopsis:
      '在木星轨道之外，监听站的年轻科学家艾拉捕捉到一段规律性的信号，而这信号竟然是早已失传的地球古语言。为了追寻信号源头，一支国际团队踏上穿越星系的旅程。影片用宏大的视觉奇观包裹一个温柔的内核：当我们向宇宙呼喊时，是否也在寻找曾经的自己？面对未知，人类最珍贵的答案或许是回头看见彼此。',
    tags: ['硬核科幻', '视效大片', '年度必看'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%2C%20an%20astronaut%20floating%20before%20a%20giant%20glowing%20planet%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20painterly%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-03-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20vast%20space%20station%20orbiting%20a%20glowing%20ember%20colored%20planet%20with%20deep%20starfields%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-03-backdrop&orientation=landscape',
    featured: true,
  },
  {
    id: 'tiexue-rongguang',
    title: '铁血荣光',
    originalTitle: 'Blood and Glory',
    type: '电影',
    region: '国产',
    genres: ['战争', '动作', '历史'],
    year: 2025,
    rating: 8.4,
    heat: 11240,
    director: '秦九霄',
    actors: ['白砚', '孟朔', '陆沉', '程野'],
    duration: '134分钟',
    releaseDate: '2025-08-01',
    summary: '一支被遗忘的连队，用血肉守住了最后一道防线。',
    synopsis:
      '故事发生在战火纷飞的年代，一支编号早已被撤销的连队接到了几乎不可能完成的任务——守住一座无名高地七十二小时。没有援军，没有补给，只有彼此。影片以极具压迫感的手持镜头还原战场真实，同时细致刻画了每个战士身后的家庭与牵挂。荣光不在勋章上，而在那些愿意为他人挡住子弹的瞬间。',
    tags: ['战争史诗', '热血', '家国情怀'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%2C%20a%20weathered%20soldier%20standing%20against%20a%20smoldering%20battlefield%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20painterly%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-04-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20muddy%20hillside%20battlefield%20at%20dawn%20with%20smoke%20and%20embers%20drifting%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-04-backdrop&orientation=landscape',
    featured: false,
  },
  {
    id: 'yinghua-zhixia',
    title: '樱花之下',
    originalTitle: 'Beneath the Sakura',
    type: '电视剧',
    region: '日韩',
    genres: ['爱情', '剧情'],
    year: 2024,
    rating: 8.5,
    heat: 9260,
    director: '佐藤凉',
    actors: ['森遥', '木村澈', '中村樱', '石井凛'],
    duration: '全16集',
    releaseDate: '2024-04-05',
    summary: '一封迟到二十年的信，让两代人的春天重新盛开。',
    synopsis:
      '小镇邮局的老邮差退休前发现一封从未送出的信，信上写着二十年前的地址。当他踏上送信之旅，一段被时间掩埋的爱情故事慢慢浮出水面。剧集分为两条时间线，在过去与现在之间往返，讲述一个关于错过与重逢的温柔故事。樱花每年都会落下，但有些人值得等上一辈子。',
    tags: ['纯爱', '细腻', '催泪'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%2C%20a%20figure%20in%20a%20light%20coat%20under%20blooming%20sakura%20petals%20in%20soft%20light%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20painterly%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-05-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20quiet%20japanese%20town%20street%20lined%20with%20sakura%20trees%20at%20golden%20hour%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-05-backdrop&orientation=landscape',
    featured: false,
  },
  {
    id: 'shenhai-mihang',
    title: '深海迷航',
    originalTitle: 'Abyssal',
    type: '电影',
    region: '欧美',
    genres: ['科幻', '惊悚', '冒险'],
    year: 2025,
    rating: 8.1,
    heat: 10380,
    director: 'Nadia Brooks',
    actors: ['Owen Hale', 'Priya Raman', 'Tobias Lund'],
    duration: '120分钟',
    releaseDate: '2025-06-13',
    summary: '一万米之下，人类发现了不该被发现的东西。',
    synopsis:
      '一支深海科考队驾驶新型潜航器抵达马里亚纳海沟最深处，却在那里探测到无法解释的声源。随着下潜深度增加，通讯开始失联，队员之间也出现了难以言说的分歧。影片将幽闭恐惧与未知恐惧推向极致，在漆黑的海底构建出一个令人窒息的世界。有些深渊，注视久了，也会回望你。',
    tags: ['深海惊悚', '沉浸体验', '视效震撼'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%2C%20a%20deep%20sea%20diver%20surrounded%20by%20glowing%20bioluminescence%20in%20dark%20water%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20painterly%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-06-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20lone%20submersible%20lit%20by%20amber%20lights%20descending%20into%20a%20black%20abyssal%20trench%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-06-backdrop&orientation=landscape',
    featured: true,
  },
  {
    id: 'zuian-zhuizong',
    title: '罪案追踪',
    originalTitle: 'Case Trace',
    type: '电视剧',
    region: '港台',
    genres: ['犯罪', '悬疑', '剧情'],
    year: 2025,
    rating: 8.3,
    heat: 8760,
    director: '何若飞',
    actors: ['郑立行', '邵韵', '唐正', '林嘉映'],
    duration: '全28集',
    releaseDate: '2025-02-28',
    summary: '每一桩案件背后，都藏着一段无人倾听的往事。',
    synopsis:
      '重案组警探与法医心理学家组成搭档，用犯罪侧写的方式侦破一宗宗看似毫无头绪的案件。剧集采用单元剧结构，每两集一个案件，同时穿插一条贯穿全季的主线谜团。它不仅讲述如何抓住凶手，更追问一个人究竟如何一步步走向深渊。真相从来不是终点，理解才是。',
    tags: ['刑侦', '单元剧', '烧脑'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%2C%20a%20detective%20reviewing%20case%20files%20under%20a%20single%20harsh%20lamp%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20painterly%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-07-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20rain%20slicked%20hong%20kong%20street%20at%20night%20with%20neon%20reflections%20in%20amber%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-07-backdrop&orientation=landscape',
    featured: false,
  },
  {
    id: 'shanhai-yimeng',
    title: '山海遗梦',
    originalTitle: 'Dreams of Mountains and Seas',
    type: '电视剧',
    region: '国产',
    genres: ['古装', '奇幻', '爱情'],
    year: 2024,
    rating: 8.0,
    heat: 13920,
    director: '云舒白',
    actors: ['谢知遥', '温砚', '沈流萤', '裴清和'],
    duration: '全40集',
    releaseDate: '2024-07-15',
    summary: '当山海异兽苏醒，一段跨越千年的缘分重新开始。',
    synopsis:
      '取材自上古神话，讲述了守山少年与化身白鹿的山灵之间跨越千年的羁绊。当封印松动、异兽苏醒，两人必须在守护苍生与厮守之间做出抉择。剧集构建了一个瑰丽东方奇幻世界，服化道考究，画面如古典长卷徐徐展开。梦里山河依旧，醒来人间已换。',
    tags: ['东方奇幻', '唯美', '国民热剧'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%2C%20an%20elegant%20figure%20in%20flowing%20hanfu%20with%20a%20glowing%20white%20deer%20beside%20them%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20painterly%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-08-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20misty%20ancient%20chinese%20mountains%20with%20floating%20islands%20and%20warm%20sunset%20clouds%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-08-backdrop&orientation=landscape',
    featured: true,
  },
  {
    id: 'mori-liming',
    title: '末日黎明',
    originalTitle: 'Dawn of the End',
    type: '电影',
    region: '欧美',
    genres: ['科幻', '动作', '灾难'],
    year: 2025,
    rating: 7.9,
    heat: 12050,
    director: 'Ryan Cole',
    actors: ['Ethan Ward', 'Sofia Marsh', 'Noah Grant'],
    duration: '138分钟',
    releaseDate: '2025-05-09',
    summary: '太阳熄灭前的最后七天，人类只能选择希望。',
    synopsis:
      '一场无法解释的天文异变让地球加速走向黑暗，仅剩的科学家团队必须在七天内完成一项几乎不可能的计划。城市陷入混乱，秩序崩塌，而一群普通人却在绝境中做出了不平凡的选择。影片用灾难片的爽感外衣，包裹着一个关于信念与团结的故事。即使天要塌下来，也总有人愿意把灯举高。',
    tags: ['末世灾难', '燃', '大制作'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%2C%20a%20lone%20survivor%20standing%20before%20a%20crumbling%20cityscape%20under%20a%20dark%20sky%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20painterly%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-09-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20dusty%20ruined%20city%20at%20sunrise%20with%20warm%20amber%20beams%20breaking%20through%20dark%20clouds%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-09-backdrop&orientation=landscape',
    featured: false,
  },
  {
    id: 'jiejiao-kafeiguan',
    title: '街角咖啡馆',
    originalTitle: 'The Corner Cafe',
    type: '电影',
    region: '国产',
    genres: ['爱情', '剧情', '喜剧'],
    year: 2024,
    rating: 7.8,
    heat: 6980,
    director: '苏念安',
    actors: ['井然', '米乐', '陆知夏'],
    duration: '108分钟',
    releaseDate: '2024-09-20',
    summary: '一家小小的咖啡馆，收留了这座城市所有的失落。',
    synopsis:
      '失意的小说家接手了姑妈留下的一家街角咖啡馆，原以为只是过渡，却在与形形色色客人的相遇中慢慢找回了写作的欲望。每一个推门而入的人，都带着自己的故事。影片节奏轻缓温暖，像冬日里一杯恰到好处的热拿铁。有时候治愈我们的，不是答案，而是有人愿意听你说完。',
    tags: ['治愈系', '小清新', '温暖'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%2C%20a%20cozy%20warm%20cafe%20window%20with%20a%20lone%20writer%20sipping%20coffee%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20painterly%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-10-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20warm%20lit%20corner%20cafe%20interior%20with%20wooden%20furniture%20and%20amber%20lamps%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-10-backdrop&orientation=landscape',
    featured: false,
  },
  {
    id: 'longying-chuanshuo',
    title: '龙影传说',
    originalTitle: 'Legend of the Dragon Shadow',
    type: '电影',
    region: '国产',
    genres: ['动画', '奇幻', '冒险'],
    year: 2025,
    rating: 8.6,
    heat: 16420,
    director: '麦川',
    actors: ['配音：星野', '黎朝', '白露'],
    duration: '112分钟',
    releaseDate: '2025-07-01',
    summary: '一个平凡少年，与守护世界的最后一头龙。',
    synopsis:
      '动画电影讲述少年阿岚意外唤醒了沉睡千年的最后一头龙，从此被卷入一场关乎世界存亡的冒险。一人一龙从互不信任到并肩作战，在旅途中学会勇气与告别。影片采用全新技术渲染，画面细腻绚烂，东方美学与现代动画工业完美融合。有些传说，值得被重新讲述。',
    tags: ['国漫之光', '合家欢', '视觉盛宴'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20animated%20movie%20poster%2C%20a%20young%20boy%20beside%20a%20majestic%20glowing%20eastern%20dragon%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20stylized%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-11-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20animated%20film%20still%20of%20a%20flying%20eastern%20dragon%20soaring%20over%20ancient%20misty%20mountains%20at%20sunset%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20stylized%20render%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-11-backdrop&orientation=landscape',
    featured: true,
  },
  {
    id: 'chenmo-de-zhengci',
    title: '沉默的证词',
    originalTitle: 'Silent Testimony',
    type: '电视剧',
    region: '国产',
    genres: ['悬疑', '犯罪', '剧情'],
    year: 2025,
    rating: 8.8,
    heat: 14210,
    director: '江之澜',
    actors: ['傅正清', '乔星然', '宋衍', '许安然'],
    duration: '全24集',
    releaseDate: '2025-04-12',
    summary: '当所有人都选择沉默，唯有证据会开口说话。',
    synopsis:
      '一桩看似普通的盗窃案，却在法医的细致检验下牵出背后庞大的利益网络。年轻法医与老练检察官联手，在层层压力中抽丝剥茧，用科学证据还原真相。剧集对司法程序刻画严谨，节奏紧凑不拖沓，同时对正义与代价进行了深刻探讨。真相也许会迟到，但绝不会缺席。',
    tags: ['悬疑', '高能', '年度口碑'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%2C%20a%20forensic%20scientist%20examining%20evidence%20under%20cold%20blue%20but%20amber%20rim%20light%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20painterly%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-12-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20dim%20forensic%20laboratory%20with%20amber%20lamps%20and%20glass%20evidence%20cases%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-12-backdrop&orientation=landscape',
    featured: false,
  },
  {
    id: 'jisu-wanjia',
    title: '极速玩家',
    originalTitle: 'Full Throttle',
    type: '电影',
    region: '欧美',
    genres: ['动作', '赛车', '犯罪'],
    year: 2024,
    rating: 7.6,
    heat: 8940,
    director: 'Diego Ferrer',
    actors: ['Cole Bennett', 'Ava Russo', 'Miles Turner'],
    duration: '124分钟',
    releaseDate: '2024-08-16',
    summary: '赛道之上，速度就是唯一的语言。',
    synopsis:
      '退役赛车手被迫重回地下赛场，为救出弟弟而参加一场横跨三座城市的亡命竞速。引擎的轰鸣、轮胎的尖叫、一触即发的对决，构成了这部肾上腺素拉满的动作电影。影片实拍大量高难度飙车镜头，同时讲述了兄弟之间无法割舍的羁绊。有些路，只能踩满油门冲过去。',
    tags: ['飙车', '爽片', '视听轰炸'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%2C%20a%20race%20car%20drifting%20with%20sparks%20and%20motion%20blur%20at%20night%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20painterly%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-13-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20highway%20street%20race%20at%20night%20with%20amber%20headlights%20and%20city%20glow%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-13-backdrop&orientation=landscape',
    featured: false,
  },
  {
    id: 'shiguang-xinjian',
    title: '时光信笺',
    originalTitle: 'Letters Through Time',
    type: '电影',
    region: '日韩',
    genres: ['剧情', '奇幻', '爱情'],
    year: 2025,
    rating: 8.4,
    heat: 7620,
    director: '小林悠真',
    actors: ['桥本遥', '高梨奏', '安藤铃'],
    duration: '116分钟',
    releaseDate: '2025-03-21',
    summary: '一个能寄信到过去的邮筒，改变了两个人的命运。',
    synopsis:
      '小镇上有一个传说：把信投进旧车站的红色邮筒，就能寄给过去的某个人。失意的摄影师抱着试一试的心态写下第一封信，却收到了来自十年前的回复。两人通过信件跨越时间相互鼓励，也逐渐被命运推向前所未料的结局。影片温柔而克制，讨论记忆、遗憾与释怀。有些告别，是为了更好的相遇。',
    tags: ['奇幻爱情', '催泪', '高口碑'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%2C%20a%20person%20holding%20a%20letter%20beside%20a%20glowing%20red%20old%20postbox%20at%20dusk%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20painterly%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-14-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20old%20rural%20train%20station%20at%20golden%20hour%20with%20a%20red%20postbox%20in%20the%20foreground%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-14-backdrop&orientation=landscape',
    featured: false,
  },
  {
    id: 'dushi-yeguiren',
    title: '都市夜归人',
    originalTitle: 'Night Owls',
    type: '电影',
    region: '港台',
    genres: ['都市', '剧情', '悬疑'],
    year: 2024,
    rating: 7.9,
    heat: 6480,
    director: '罗启铭',
    actors: ['张柏尧', '何雨桐', '曾国安'],
    duration: '110分钟',
    releaseDate: '2024-10-25',
    summary: '出租车司机的一个夜晚，看见了一座城市的众生相。',
    synopsis:
      '影片以一夜之间的一辆出租车为舞台，通过接连上车的乘客展开多条人生线索。醉酒的商人、逃家的少年、相拥的恋人、独行的老人……每位乘客都带走一段故事，也在司机心里留下痕迹。当黎明到来，司机做出了改变自己人生的决定。城市很大，但每个人的深夜都值得被温柔以待。',
    tags: ['城市群像', '文艺', '真实感'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%2C%20a%20taxi%20driver%20silhouette%20seen%20through%20rain%20on%20a%20car%20window%20at%20night%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20painterly%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-15-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20rainy%20city%20street%20at%20night%20seen%20through%20a%20taxi%20windshield%20with%20amber%20lights%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-15-backdrop&orientation=landscape',
    featured: false,
  },
  {
    id: 'wangchao-fengyun',
    title: '王朝风云',
    originalTitle: 'Dynasty Storm',
    type: '电视剧',
    region: '国产',
    genres: ['历史', '古装', '权谋'],
    year: 2025,
    rating: 8.7,
    heat: 15890,
    director: '裴仲言',
    actors: ['萧景明', '苏怀瑾', '陆廷昭', '安如月'],
    duration: '全48集',
    releaseDate: '2025-01-08',
    summary: '一个王朝的兴衰，藏在朝堂之下的暗流里。',
    synopsis:
      '剧集以架空王朝为背景，通过一位寒门出身的年轻谏臣的视角，展现朝堂之上的权谋博弈与家国情怀。从边关战事到赋税改革，从储位之争到民心所向，每一个决策都牵动千万人的命运。制作精良，台词考究，群像塑造饱满。史书上寥寥数笔的背后，是无数人的波澜一生。',
    tags: ['权谋', '大制作', '群像'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%2C%20a%20regal%20figure%20in%20ornate%20ancient%20chinese%20robes%20before%20a%20grand%20palace%20hall%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20painterly%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-16-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20vast%20ancient%20chinese%20palace%20courtyard%20at%20dusk%20with%20warm%20amber%20torchlight%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-16-backdrop&orientation=landscape',
    featured: true,
  },
  {
    id: 'huanjing-bianyuan',
    title: '幻境边缘',
    originalTitle: 'Edge of Illusion',
    type: '电视剧',
    region: '欧美',
    genres: ['奇幻', '冒险', '悬疑'],
    year: 2024,
    rating: 8.1,
    heat: 9350,
    director: 'Helena Marsh',
    actors: ['Jasper Blythe', 'Isla Rooney', 'Felix Ward'],
    duration: '全10集',
    releaseDate: '2024-12-06',
    summary: '一个普通小镇，藏着一扇通往另一个世界的门。',
    synopsis:
      '少女奥莉薇在整理祖母遗物时发现一枚古怪的怀表，从此能看见常人看不见的裂痕。这些裂痕连接着一个与现实交错的奇幻世界，而两个世界正面临同时崩塌的危机。剧集视觉设计奇思妙想，节奏张弛有度，讲述关于成长与勇气的故事。门后面是什么，取决于你敢不敢推开。',
    tags: ['奇幻', '青春冒险', '高设定'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%2C%20a%20girl%20holding%20a%20glowing%20pocket%20watch%20before%20a%20rift%20of%20light%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20painterly%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-17-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20quiet%20town%20street%20split%20by%20a%20glowing%20magical%20rift%20of%20amber%20light%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-17-backdrop&orientation=landscape',
    featured: false,
  },
  {
    id: 'pingfan-suiyue',
    title: '平凡岁月',
    originalTitle: 'Ordinary Years',
    type: '电视剧',
    region: '国产',
    genres: ['家庭', '剧情', '年代'],
    year: 2025,
    rating: 8.3,
    heat: 10740,
    director: '田敬川',
    actors: ['高怀民', '章素芬', '田小满', '钱多多'],
    duration: '全38集',
    releaseDate: '2025-05-20',
    summary: '一个普通家庭四十年，是时代最真实的注脚。',
    synopsis:
      '剧集横跨四十年时光，讲述一个普通工薪家庭从筒子楼到新小区的变迁，以及三代人在时代浪潮中的聚散与成长。没有惊天动地的传奇，只有柴米油盐里的坚持，和饭桌边一代代传下去的温度。它让每个观众都能在里面看到自己的父母、自己的家。平凡，本身就是最动人的故事。',
    tags: ['年代剧', '口碑', '合家欢'],
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%2C%20a%20warm%20family%20gathered%20around%20a%20dinner%20table%20under%20an%20amber%20lamp%2C%20central%20subject%20on%20a%20simple%20deep%20crimson%20and%20charcoal%20gradient%20background%2C%20dramatic%20rim%20lighting%2C%20painterly%20illustration%2C%20high%20detail%2C%20harmonious%20composition%2C%20modern%20minimal%20graphic%20design%2C%20no%20text&width=600&height=900&seq=movie-18-poster&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20old%20chinese%20residential%20alley%20at%20sunset%20with%20warm%20amber%20light%20through%20windows%2C%20wide%20atmospheric%20scene%2C%20moody%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20photorealistic%2C%20high%20detail%2C%20cinematic%20color%20grading%2C%20dramatic%20composition%2C%20no%20text&width=1920&height=1080&seq=movie-18-backdrop&orientation=landscape',
    featured: true,
  },
];

export const regions = ['全部', '国产', '欧美', '日韩', '港台'];

export const types = ['全部', '电影', '电视剧'];

export const years = ['全部', '2025', '2024'];

export const genres = [
  '全部',
  '剧情',
  '悬疑',
  '动作',
  '爱情',
  '科幻',
  '犯罪',
  '古装',
  '奇幻',
  '喜剧',
  '战争',
  '历史',
  '家庭',
  '动画',
  '冒险',
  '都市',
];